let storeContent = utils.generateStore({
	cartItems: [],
	showPaymentModal: false,
	selectedProduct: {},
	paymentPage: 1,
	balance: 0,
	paymentComplete: false,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchClientAccountBalance(ctx, accNo) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: {
							account_number: accNo,
						},
					},
					'/client',
				);

				ctx.commit('balance', res.result.available_balance);
			} catch (err) {
				throw err;
			}
		},
		async deleteInvoice(ctx, invoice) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'cart',
						action: 'remove',
						data: {
							invoice_id: invoice.invoice_id,
						},
					},
					'/client',
				);

				await ctx.dispatch('fetchCartItems');
				$notify(
					'success',
					'Invoice Deleted',
					`Invoice for product: ${invoice.product_name} has been successfully deleted`,
					5,
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchCartItems(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice',
						action: 'list',
						data: {},
					},
					'/client',
				);

				let invoices = res.result.client_invoices.invoices.filter(
					(invoice) => {
						if (invoice.invoice_status !== 'PAID') {
							return true;
						} else {
							return false;
						}
					},
				);

				ctx.commit('cartItems', invoices);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async payInvoice(ctx) {
			try {
				ctx.commit('loading', true);
				ctx.commit('paymentComplete', false);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice',
						action: 'payment',
						data: {
							invoice_id: ctx.getters.selectedProduct.invoice_id,
						},
					},
					'/client',
				);

				if (res.result.tran_number) {
					ctx.commit('paymentComplete', true);
					await ctx.dispatch('fetchCartItems');
					await ctx.dispatch(
						'fetchClientAccountBalance',
						ctx.getters.selectedProduct.invoice_details
							.client_account_details.account_number,
					);
				}
				ctx.commit('loading', false);
				ctx.commit('paymentPage', 2);
			} catch (err) {
				ctx.commit('loading', false);
				ctx.commit('paymentPage', 2);
				throw err;
			}
		},
		async openIPFModal(ctx, payload) {
			try {
				Event.$emit('ipf:show', { item: payload });
			} catch (err) {
				throw err;
			}
		},
		async openPaymentModal(ctx, payload) {
			try {
				ctx.commit('paymentPage', 1);
				ctx.commit('showPaymentModal', true);
				ctx.commit('selectedProduct', payload.item);
			} catch (err) {
				throw err;
			}
		},
	},
};
